class ContratoCertificadoModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'FileUploader', 'contrato' ]

  constructor: ($injector, @modalInstance, FileUploader, contrato) ->
    super($injector)
    @empresa = contrato
    @certificado = false
    @password = ''
    if contrato.certificadoA1?
      @certificado = contrato.certificadoA1

    @uploader = new FileUploader(
      url: "/api/eficiencia-fiscal/certificado-a1"
      headers: cbk.getHeaders()
      removeAfterUpload: true
      onBeforeUploadItem: (item) =>
        item.formData = [ {
          contrato: contrato.id
          password: @password
        } ]
    )

    @uploader.onCompleteItem = (fileItem, response, status, headers) =>

      erros = {
        senha_ou_formato_invalidado: 'Senha ou certificado invalido.'
        certificado_nao_lido: 'Certificado digital não reconhecido.'
        certificado_vencido: 'Certificado digital vencido.'
        raiz_certificado_invalida: 'Certificado inválido para o CNPJ atual.'
        default: 'Ocorreu um erro ao enviar o certificado.'
      }

      if(response.success)
        @Alert.success('Certificado enviado com sucesso!', 'Enviado com sucesso')
        @modalInstance.close(new Retorno(true))
      else
        if erros[response.message] == undefined
          message = erros.default
        else
          message = erros[response.message]
        @password = ''
        $('#file').val('')
        @Alert.warning(message, 'Atenção')


  salvar: (form) ->
    form.$submitted = true
    if form.$valid
      @uploader.uploadAll()

angular.module("eficienciaFiscalModule").controller('contratoCertificadoModalController', ContratoCertificadoModalController)